if (!window.PIXI) throw new Error("Всё поменялось и поломалось! Добавьте import нужной версии PIXI из '../../PIXI/bin/pixi_*.js' в ваш main.js (не забудьте перед этим обновить фреймворк)");

import { MOBILE, ANDROID, CHROME, FIREFOX } from './layout/features';

if(MOBILE && ANDROID && !CHROME && !FIREFOX) {
    let lastTime = Date.now();

    window.requestAnimationFrame = function (callback) {
        if (typeof callback !== 'function') {
            throw new TypeError(callback + 'is not a function');
        }

        var currentTime = Date.now(), delay = 16 + lastTime - currentTime;

        if (delay < 0) delay = 0;

        lastTime = currentTime;

        return setTimeout(function () {
            lastTime = Date.now();
            callback(lastTime);
        }, delay);
    };
}

/**
 * Глобальные переменные и константы.
 * @module globals
 */

/**
 * Application instance
 * @type {Application}
 */
let APP = null;

/**
 * Sets the app instance
 * @param {Application} app
 */
function setApplication(app){
    APP = app;
}

/**
 * Horizontal align
 * @type {{LEFT: number, CENTER: number, RIGHT: number, JUSTIFY: number}}
 * @property {Number} LEFT Выравнивание по левому краю
 * @property {Number} CENTER Выравнивание по центру
 * @property {Number} RIGHT Выравнивание по правому краю
 * @property {Number} JUSTIFY Выравнивание по ширине
 * @constant
 */
const ALIGN = {
    LEFT: -1,
    CENTER: 0,
    RIGHT: 1,
    JUSTIFY: 2
};

/**
 * Vertical align
 * @type {{TOP: number, MIDDLE: number, BOTTOM: number}}
 * @property {Number} TOP Выравнивание по верхнему краю
 * @property {Number} MIDDLE Выравнивание по центру
 * @property {Number} BOTTOM Выравнивание по нижнему краю
 * @constant
 */
const VALIGN = {
    TOP: -1,
    MIDDLE: 0,
    BOTTOM: 1
};

import * as CACHE from './storage/cache';
export { CACHE };
export { ALIGN, VALIGN };
export { APP, setApplication };

//----------------------------------------------------------------------------------------------------------------------
if (!Array.from) Array.from = function(arg){
    var res = [];
    for (var entry of arg) res.push(entry);
    return res;
}